import {
  GET_USER_REQ,
  GET_USER_SUCCESS,
  GET_USER_ERROR,
  CREATE_USER_REQ,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  GET_USER_DETAIL_REQ,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_ERROR,
  GET_COMPANY_DETAIL_REQ,
  GET_COMPANY_DETAIL_SUCCESS,
  GET_COMPANY_DETAIL_ERROR,
  GET_LOCATION_REQ,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_ERROR,
  GET_CARD_REQ,
  GET_CARD_SUCCESS,
  GET_CARD_ERROR,
  CREATE_LOCATION_REQ,
  CREATE_LOCATION_SUCCESS,
  CREATE_LOCATION_ERROR,
  DELETE_LOCATION_REQ,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_ERROR,
  UPDATE_LOCATION_REQ,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_LOCATION_ERROR,
  UPDATE_ASSETS_REQ,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_ASSETS_ERROR,
  UPDATE_BUSINESS_INFO_REQ,
  UPDATE_BUSINESS_INFO_SUCCESS,
  UPDATE_BUSINESS_INFO_ERROR,
  UPDATE_PROFILE_INFO_REQ,
  UPDATE_PROFILE_INFO_SUCCESS,
  UPDATE_PROFILE_INFO_ERROR,
  CREATE_ASSETS_REQ,
  CREATE_ASSETS_SUCCESS,
  CREATE_ASSETS_ERROR,
  DELETE_CARD_REQ,
  DELETE_CARD_SUCCESS,
  DELETE_CARD_ERROR,
  SET_CARD_DEFAULT_REQ,
  SET_CARD_DEFAULT_SUCCESS,
  SET_CARD_DEFAULT_ERROR,
  GET_ZIP_CODE_REQ,
  GET_ZIP_CODE_SUCCESS,
  GET_ZIP_CODE_ERROR,
  VERIFY_ZIP_CODE_REQ,
  VERIFY_ZIP_CODE_SUCCESS,
  VERIFY_ZIP_CODE_ERROR,
  CREATE_TOKEN_REQ,
  CREATE_TOKEN_SUCCESS,
  CREATE_TOKEN_ERROR,
  CREATE_CARD_REQ,
  CREATE_CARD_SUCCESS,
  CREATE_CARD_ERROR,
  GET_SUBSCRIPTION_PLAN_REQ,
  GET_SUBSCRIPTION_PLAN_SUCCESS,
  GET_SUBSCRIPTION_PLAN_ERROR,
  CREATE_SUBSCRIPTION_REQ,
  CREATE_SUBSCRIPTION_SUCCESS,
  CREATE_SUBSCRIPTION_ERROR,
  DOWNLOAD_RECIPT_REQ,
  DOWNLOAD_RECIPT_SUCCESS,
  DOWNLOAD_RECIPT_ERROR,
  SHARE_RECIPT_REQ,
  SHARE_RECIPT_SUCCESS,
  SHARE_RECIPT_ERROR,
  CONNECT_STRIPE_ERROR,
  CONNECT_STRIPE_REQ,
  CONNECT_STRIPE_SUCCESS,
  CREATE_REACTIVATION_SUBSCRIPTION_REQ,
  CREATE_REACTIVATION_SUBSCRIPTION_SUCCESS,
  CREATE_REACTIVATION_SUBSCRIPTION_ERROR,
  CREATE_CANCELLATION_SUBSCRIPTION_REQ,
  CREATE_CANCELLATION_SUBSCRIPTION_SUCCESS,
  CREATE_CANCELLATION_SUBSCRIPTION_ERROR,

} from "../constants";

export default class UserAction {
  static getUserReq(id, params) {
    return {
      type: GET_USER_REQ,
      id,
      params,
    };
  }
  static getUserSuccess(res, id, metaData) {
    return {
      type: GET_USER_SUCCESS,
      res,
      id,
      metaData,
    };
  }
  static getUserError(e) {
    return {
      type: GET_USER_ERROR,
      e,
    };
  }
  static createUserReq(payload, cb, params) {
    return {
      type: CREATE_USER_REQ,
      payload,
      cb,
      params,
    };
  }
  static createUserSuccess(res) {
    return {
      type: CREATE_USER_SUCCESS,
      res,
    };
  }
  static createUserError(e) {
    return {
      type: CREATE_USER_ERROR,
      e,
    };
  }

  static getUserDetailReq(userId, cb) {
    return {
      type: GET_USER_DETAIL_REQ,
      userId,
      cb,
    };
  }
  static getUserDetailSuccess(res) {
    return {
      type: GET_USER_DETAIL_SUCCESS,
      res,
    };
  }
  static getUserDetailError(e) {
    return {
      type: GET_USER_DETAIL_ERROR,
      e,
    };
  }

  // static getCompantDetailReq() {
  //   return {
  //     type: GET_COMPANY_DETAIL_REQ,
  //   };
  // }
  static getCompantDetailReq(id, cb) {
    return {
      type: GET_COMPANY_DETAIL_REQ,
      id,
      cb
    };
  }
  static getCompanyDetailSuccess(res) {
    return {
      type: GET_COMPANY_DETAIL_SUCCESS,
      res,
    };
  }
  static getCompanyDetailError(e) {
    return {
      type: GET_COMPANY_DETAIL_ERROR,
      e,
    };
  }
  static getLocationReq() {
    return {
      type: GET_LOCATION_REQ,
    };
  }
  static getLocationSuccess(res) {
    return {
      type: GET_LOCATION_SUCCESS,
      res,
    };
  }
  static getLocationError(e) {
    return {
      type: GET_LOCATION_ERROR,
      e,
    };
  }
  static getCardsReq(params) {
    return {
      type: GET_CARD_REQ,
      params,
    };
  }
  static getCardsSuccess(res, meta) {
    return {
      type: GET_CARD_SUCCESS,
      res,
      meta
    };
  }
  static getCardsError(e) {
    return {
      type: GET_CARD_ERROR,
      e,
    };
  }
  static createLocationReq(payload, cb) {
    return {
      type: CREATE_LOCATION_REQ,
      payload,
      cb,
    };
  }
  static createLocationSuccess(res) {
    return {
      type: CREATE_LOCATION_SUCCESS,
      res,
    };
  }
  static createLocationError(e) {
    return {
      type: CREATE_LOCATION_ERROR,
      e,
    };
  }
  static deleteLocationReq(id, cb) {
    return {
      type: DELETE_LOCATION_REQ,
      id,
      cb,
    };
  }
  static deleteLocationSuccess(res) {
    return {
      type: DELETE_LOCATION_SUCCESS,
      res,
    };
  }
  static deleteLocationError(e) {
    return {
      type: DELETE_LOCATION_ERROR,
      e,
    };
  }

  static UpdateLocationReq(body, id, cb) {
    return {
      type: UPDATE_LOCATION_REQ,
      body,
      id,
      cb,
    };
  }
  static UpdateLocationSuccess(id, data) {
    return {
      type: UPDATE_LOCATION_SUCCESS,
      id,
      data,
    };
  }
  static UpdateLocationError(e) {
    return {
      type: UPDATE_LOCATION_ERROR,
      e,
    };
  }

  static updateAssetsReq(id, body, cb) {
    return {
      type: UPDATE_ASSETS_REQ,
      body,
      id,
      cb,
    };
  }
  static updateAssetsSuccess(id, data) {
    return {
      type: UPDATE_ASSETS_SUCCESS,
      id,
      data,
    };
  }
  static updateAssetsError(e) {
    return {
      type: UPDATE_ASSETS_ERROR,
      e,
    };
  }

  static updateBusinessInfoReq(body, cb) {
    return {
      type: UPDATE_BUSINESS_INFO_REQ,
      body,
      cb,
    };
  }
  static updateBusinessInfoSuccess(id, data) {
    return {
      type: UPDATE_BUSINESS_INFO_SUCCESS,
      id,
      data,
    };
  }
  static updateBusinessInfoError(e) {
    return {
      type: UPDATE_BUSINESS_INFO_ERROR,
      e,
    };
  }

  static updateProfileInfoReq(body, cb, id, active) {
    return {
      type: UPDATE_PROFILE_INFO_REQ,
      body,
      cb,
      id,
      active,
    };
  }
  static updateProfileInfoSuccess(id, data) {
    return {
      type: UPDATE_PROFILE_INFO_SUCCESS,
      id,
      data,
    };
  }
  static updateProfileInfoError(e) {
    return {
      type: UPDATE_PROFILE_INFO_ERROR,
      e,
    };
  }

  static createAssetsReq(body, cb, id, active) {
    return {
      type: CREATE_ASSETS_REQ,
      body,
      cb,
      id,
      active,
    };
  }
  static createAssetsSuccess(id, data) {
    return {
      type: CREATE_ASSETS_SUCCESS,
      id,
      data,
    };
  }
  static createAssetsError(e) {
    return {
      type: CREATE_ASSETS_ERROR,
      e,
    };
  }

  static deleteCardReq(cardId, cb, id, active) {
    return {
      type: DELETE_CARD_REQ,
      cardId,
      cb,

      id,
    };
  }
  static deleteCardSuccess(id, data) {
    return {
      type: DELETE_CARD_SUCCESS,
      id,
      data,
    };
  }
  static deleteCardError(e) {
    return {
      type: DELETE_CARD_ERROR,
      e,
    };
  }

  static setCardDefaultReq(cardId, cb, id, active) {
    return {
      type: SET_CARD_DEFAULT_REQ,
      cardId,
      cb,
    };
  }
  static setCardDefaultSuccess(id, data) {
    return {
      type: SET_CARD_DEFAULT_SUCCESS,
      id,
      data,
    };
  }
  static setCardDefaultError(e) {
    return {
      type: SET_CARD_DEFAULT_ERROR,
      e,
    };
  }

  static verify_zipcode_req(payload, cb) {
    return {
      type: VERIFY_ZIP_CODE_REQ,
      payload,
      cb,
    };
  }
  static verify_zipcode_success(data) {
    return {
      type: VERIFY_ZIP_CODE_SUCCESS,
      data,
    };
  }
  static verify_zipcode_error(e) {
    return {
      type: VERIFY_ZIP_CODE_ERROR,
      e,
    };
  }
  static createTokenReq(payload, cb,callback) {
    return {
      type: CREATE_TOKEN_REQ,
      payload,
      cb,
      callback
    };
  }
  static createTokenSucess(data) {
    return {
      type: CREATE_TOKEN_SUCCESS,
      data,
    };
  }
  static createTokenError(e) {
    return {
      type: CREATE_TOKEN_ERROR,
      e,
    };
  }
  static createCardReq(payload, cb, orderId) {
    return {
      type: CREATE_CARD_REQ,
      payload,
      cb,
    };
  }
  static createCardSuccess(data) {
    return {
      type: CREATE_CARD_SUCCESS,
      data,
    };
  }
  static createCardError(e) {
    return {
      type: CREATE_CARD_ERROR,
      e,
    };
  }
  static getSubscriptionPlanReq(payload, cb) {
    return {
      type: GET_SUBSCRIPTION_PLAN_REQ,
      payload,
      cb,
    };
  }
  static getSubscriptionPlanSucess(data) {
    return {
      type: GET_SUBSCRIPTION_PLAN_SUCCESS,
      data,
    };
  }
  static getSubscriptionPlanError(e) {
    return {
      type: GET_SUBSCRIPTION_PLAN_ERROR,
      e,
    };
  }
  static createSubscriptionReq(payload, cb) {
    return {
      type: CREATE_SUBSCRIPTION_REQ,
      payload,
      cb,
    };
  }
  static createSubscriptionSucess(data) {
    return {
      type: CREATE_SUBSCRIPTION_SUCCESS,
      data,
    };
  }
  static createSubscriptionError(e) {
    return {
      type: CREATE_SUBSCRIPTION_ERROR,
      e,
    };
  }

  static downloadReciptReq(payload, cb, orderId) {
    return {
      type: DOWNLOAD_RECIPT_REQ,
      payload,
      cb,
      orderId,
    };
  }
  static downloadReciptSuccess(data) {
    return {
      type: DOWNLOAD_RECIPT_SUCCESS,
      data,
    };
  }
  static downloadReciptError(e) {
    return {
      type: DOWNLOAD_RECIPT_ERROR,
      e,
    };
  }
  static shareReciptReq(payload, cb, orderId) {
    return {
      type: SHARE_RECIPT_REQ,
      payload,
      cb,
      orderId,
    };
  }
  static shareReciptSuccess(data) {
    return {
      type: SHARE_RECIPT_SUCCESS,
      data,
    };
  }
  static shareReciptError(e) {
    return {
      type: SHARE_RECIPT_ERROR,
      e,
    };
  }

  static connectStipeReq(payload,cb) {
    return {
      type: CONNECT_STRIPE_REQ,
      payload,
      cb
    };
  }
  static connectStipeSuccess(data) {
    return {
      type: CONNECT_STRIPE_SUCCESS,
      data,
    };
  }
  static connectStipeError(e) {
    return {
      type: CONNECT_STRIPE_ERROR,
      e,
    };
  }
  static postSubscribitionReactivationReq(payload, cb) {
    return {
      type: CREATE_REACTIVATION_SUBSCRIPTION_REQ,
      payload,
      cb,
    };
  }
  static postSubscribitionReactivationSuccess(data) {
    return {
      type: CREATE_REACTIVATION_SUBSCRIPTION_SUCCESS,
      data,
    };
  }
  static postSubscribitionReactivationError(e) {
    return {
      type: CREATE_REACTIVATION_SUBSCRIPTION_ERROR,
      e,
    };
  }
  static postSubscribitionCancellationReq(payload, cb) {
    return {
      type: CREATE_CANCELLATION_SUBSCRIPTION_REQ,
      payload,
      cb,
    };
  }
  static postSubscribitionCancellationSuccess(data) {
    return {
      type: CREATE_CANCELLATION_SUBSCRIPTION_SUCCESS,
      data,
    };
  } s
  static postSubscribitionCancellationError(e) {
    return {
      type: CREATE_CANCELLATION_SUBSCRIPTION_ERROR,
      e,
    };
  }

}
